module.exports = __webpack_public_path__ + "img/87_12.3ca99fdf.png";